// @flow
import * as React from 'react';
import { Input, Menu, Button, Dropdown, Upload } from 'antd';
import { connect } from 'react-redux';
import {CloudDownloadOutlined, CloudUploadOutlined, UploadOutlined} from '@ant-design/icons';
import { PERMISSIONS, permit } from '../../../Evolve/Utilities/permissions';
import { isAdmin } from 'Common';

const styles = {

  stack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 25
  },

  heading: {
    flex: 1,
    margin: 0
  }
}

type Props = {
  searchTerm: string,
  userPermissions: [],
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onUpload: () => void,
  onClickExport: () => void,
  onClickNewClient: () => void
}

class Header extends React.PureComponent<Props> {

  render () {

    const {
      searchTerm,
      userPermissions,
      onClickNewClient,
      onSubmitSearch,
      onChangeSearch,
      onUpload,
      onClickExport,
    } = this.props;

    const exportMenu = (
      <Menu onClick={onClickExport}>
        <Menu.Item key="clients">Export All Clients</Menu.Item>
        <Menu.Item key="client-sites">Export All Sites</Menu.Item>
        <Menu.Item key="client-contacts">Export All Contacts</Menu.Item>
      </Menu>
    );

    return (
      <div class="_header_bar">

        <h1>
          Clients
        </h1>

        <Input.Search
          value={searchTerm}
          onChange={onChangeSearch}
          onSearch={onSubmitSearch}
          placeholder="Search"
          enterButton
          style={{ width: 250 }}
        />

          <div style={{ width: 10 }} />

          <Upload
              name="file"
              customRequest={onUpload}
              showUploadList={false}
          >
              <Button>
                  <UploadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
          </Upload>

        {(isAdmin() && permit(userPermissions, 'exports')) && (

          <React.Fragment>

            <div style={{ width: 10 }} />

            <Dropdown overlay={exportMenu}>
              <Button>
                <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
            </Dropdown>

          </React.Fragment>

        )}

        <div style={{ width: 10 }} />

        <Button type="primary" onClick={onClickNewClient}>
          New Client
        </Button>

      </div>

    )
  }
}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Header)
